import { combineReducers } from 'redux';
import user from './user';
import customers from './customers';
import creditLimits from './credit-limits';
import longSteelOrders from './long-steel-orders';
import invoices from './invoices';
import longSteelShoppingCart from './long-steel-shopping-cart';
import longSteelOrderItemSearch from './long-steel-order-item-search';
import dashboard from './dashboard';
import downloadArea from './download-area';
import fabricationProjects from './fabrication-projects';
import fabricationMockups from './fabrication-mockups';
import fabricationContracts from './fabrication-contracts';
import acessManagement from './access-management';
import fabrication from './fabrication';
import fabricationPurchaseOrder from './fabrication-purchase-order';
import contractsAndConstructions from './contracts-and-constructions';
import toastMessages from './toast';
import notifications from './notifications';
import fabricationOrders from './fabrication-orders';
import observability from './observability';
import loyalty from './loyalty';
import orderSimulateCheckoutMvp from './order-simulate-checkout-mvp';
import cartItemsMvp from './cart-items-mvp/reducer';
import auth from './auth';

export default combineReducers({
  auth,
  user,
  acessManagement,
  customers,
  notifications,
  dashboard,
  downloadArea,
  longSteelOrders,
  invoices,
  creditLimits,
  longSteelShoppingCart,
  longSteelOrderItemSearch,
  loyalty,
  fabrication,
  fabricationPurchaseOrder,
  contractsAndConstructions,
  fabricationContracts,
  fabricationProjects,
  fabricationMockups,
  fabricationOrders,
  observability,
  toastMessages,
  orderSimulateCheckoutMvp,
  cartItemsMvp
});
